import { events, messageBus } from '@schibsted-nmp/advertising-events';
import { debugLog } from '@schibsted-nmp/advertising-shared';
import { $config } from '@client/core/atoms/config';

import { searchFilterCallback } from '../refreshKeywords';
import { $interminglePlacements } from '../../atoms/placements';

export function setupEvents() {
  const { pageType, brand, vertical } = $config.get();
  const interminglePlacements = $interminglePlacements.get();
  debugLog('placementsWithIntermingle: ', interminglePlacements);

  if (interminglePlacements.length > 0) {
    messageBus.publish(
      events.PODLET.channel,
      events.PODLET.PODLET_READY.topic,
      events.PODLET.PODLET_READY.sendPayload({
        placementsWithIntermingle: interminglePlacements
      })
    );
  }

  if (pageType === 'result') {
    messageBus.subscribe(
      events.SEARCH.channel,
      events.SEARCH.FILTER.topic,
      searchFilterCallback
    );

    const verticalsUsingSearchQuest = ['b2b', 'boat', 'mc'];
    if (brand === 'finn' && verticalsUsingSearchQuest.includes(vertical)) {
      // Some old code (search-quest-front) uses this channel/topic.
      // Will be removed when search-quest-front is deprecated (soon TM).
      messageBus.subscribe('filter', 'updated', searchFilterCallback);
    }
  }
}
